import { BffOverview } from "product-test-types";

import { STRAPI_URL } from "../env";

export async function fetchOverview(): Promise<BffOverview | undefined> {
  try {
    const response = await fetch(`${STRAPI_URL}/bff-overview`, {
      credentials: "include",
    });

    if (response.status >= 400) {
      throw new Error(`Fetch failed with status ${response.status}.`);
    }

    const json = (await response.json()) as BffOverview;

    return json;
  } catch {
    return;
  }
}
